import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import apiServices from "../../services/service";
import { leadInputData } from "../../shared/constants";

const defaultColDef = {
  sortable: true,
  filter: true,
  resizable: true,
  flex: 1,
  minWidth: 120,
};

const colDefs = [
  {
    field: "fullName",
    headerName: "Full Name",
    minWidth: 160,
    flex: 1.2,
    valueFormatter: (p) => p.value || "-",
  },
  {
    field: "companyName",
    headerName: "Company",
    minWidth: 150,
    flex: 1,
    valueFormatter: (p) => p.value || "-",
  },
  {
    field: "email",
    headerName: "Email",
    minWidth: 180,
    flex: 1.3,
    valueFormatter: (p) => p.value || "-",
  },
  {
    field: "phone",
    headerName: "Phone",
    minWidth: 130,
    flex: 0.9,
    valueFormatter: (p) => p.value || "-",
  },
  {
    field: "owner",
    headerName: "Lead Owner",
    minWidth: 140,
    flex: 1,
    valueFormatter: (p) => p.value || "-",
  },
  {
    field: "leadSource",
    headerName: "Lead Source",
    minWidth: 130,
    flex: 0.9,
    valueFormatter: (p) => p.value || "-",
  },
];

const LeadsMyLeadsTab = ({ recordVisibility }) => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    apiServices
      .getLeadList({
        ...leadInputData,
        generalRecordVisibility: 'Own',
        teamRecordVisibility: null,
        bucketRecordVisibility: null,
        teamId: null,
        bucketId: null,
      })
      .then((response) => setLeads(response.data?.leads || []))
      .catch((error) => console.error("Error fetching my leads:", error))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div
      style={{
        height: "calc(100vh - 160px)",
        padding: "16px",
        boxSizing: "border-box",
      }}
    >
      <div className="ag-theme-balham" style={{ height: "100%", width: "100%" }}>
        <AgGridReact
          rowData={leads}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          rowHeight={42}
          animateRows
          suppressRowClickSelection
          alwaysShowVerticalScroll
          loading={loading}
          onGridReady={(params) => params.api.sizeColumnsToFit()}
          overlayNoRowsTemplate="<span style='color:#999'>No leads assigned to you.</span>"
        />
      </div>
    </div>
  );
};

export default LeadsMyLeadsTab;
